import {
  AddPromotionBtn,
  Card,
  Container,
  ContainerRow,
  Date,
  Description,
  DescriptionTitle,
  Div,
  DurationText,
  DurationWrap,
  Flex,
  Header,
  Location,
  NumberOfViews,
  PromotionImage,
  PromotionName,
  RightHandSideConainer,
  Row,
  Title,
  CustomAgentCard,
  ToText,
  ViewContainer,
  ViewsText
} from './style';
import { ReactComponent as LocationIcon } from '../../../assets/location_icon.svg';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { IPromotion } from '../../../store/promotion/interface';
import { getDateString } from '../../../utils/date';
import { EditPromotion } from '../components/promotionModal/editPromotion';
import { useGetPromotionByIdQuery } from '../../../store/promotion/api';
import { Loader } from '../../../component/loader';

export const ViewPromotion = () => {
  const { state } = useLocation();
  const [promotionId] = useState(
    (state as { promotionId: string }).promotionId
  );
  const [editPromotionsModal, setEditPromotionsModal] = useState(false);
  const [promotionDetails, setPromotionDetails] = useState<IPromotion>();

  const { data: promotionData, isLoading: isPromotionDataLoading } =
    useGetPromotionByIdQuery(promotionId);

  useEffect(() => {
    if (promotionData) {
      setPromotionDetails(promotionData.data);
    }
  }, [promotionData]);

  const handleEditPromotions = () => {
    setEditPromotionsModal(true);
  };
  return (
    <Container>
      {isPromotionDataLoading && <Loader />}
      <Header>
        <Title>Promotion</Title>
        <AddPromotionBtn onClick={handleEditPromotions}>
          Edit Promotion
        </AddPromotionBtn>
        {editPromotionsModal && promotionDetails && (
          <EditPromotion
            promotionInfo={promotionDetails}
            setShow={setEditPromotionsModal}
          />
        )}
      </Header>
      <ContainerRow>
        <Card>
          <PromotionImage images={promotionDetails?.files ?? []} />
          <Div>
            <Row>
              <PromotionName>{promotionDetails?.name}</PromotionName>
              <DurationWrap>
                <DurationText>Duration: </DurationText>
                <Date>
                  {getDateString(promotionDetails?.duration?.from ?? '')}
                </Date>{' '}
                <ToText>to</ToText>
                <Date>
                  {getDateString(promotionDetails?.duration?.to ?? '')}
                </Date>
              </DurationWrap>
            </Row>
            <Row>
              <Flex>
                <LocationIcon />
                <Location>{promotionDetails?.location}, Nigeria</Location>
              </Flex>
            </Row>
            <DescriptionTitle>Description</DescriptionTitle>
            <Description>{promotionDetails?.description}</Description>
          </Div>
        </Card>
        <RightHandSideConainer>
          {promotionDetails?.agent && (
            <CustomAgentCard hideDelete agent={promotionDetails?.agent} />
          )}
          <ViewContainer>
            <ViewsText>Views</ViewsText>
            <NumberOfViews>{promotionDetails?.views ?? '0'}</NumberOfViews>
          </ViewContainer>
        </RightHandSideConainer>
      </ContainerRow>
    </Container>
  );
};
